import { render, staticRenderFns } from "./EquipmentGroup.vue?vue&type=template&id=2710ed95&scoped=true&"
import script from "./EquipmentGroup.vue?vue&type=script&lang=js&"
export * from "./EquipmentGroup.vue?vue&type=script&lang=js&"
import style1 from "./EquipmentGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710ed95",
  null
  
)

export default component.exports